if ('serviceWorker' in window.navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (registration) => {
        console.log("[pwa.js] - Service worker registered");

        if (!registration) return;

        setInterval(() => checkForUpdate(url, registration), 30 * 60 * 1000);
      }
    )
  })
}

async function checkForUpdate(url, registration) {
  console.log("[pwa.js] - Checking for updates");

  if (registration.installing || !navigator) return;

  if (("connection" in navigator) && !navigator.onLine) return;

  const response = await fetch(url, {
    cache: "no-store",
    headers: {
      "cache": "no-store",
      "cache-controle": "no-cache",
    },
  });

  console.log("[pwa.js] - Update found, new content will be downloaded");

  if (response.status === 200) registration.update();
}
